"use client";

import React from "react";
import "../privacy-policy/PrivacyPolicy.scss";
import Link from "next/link";
import { ReactSVG } from "react-svg";

const RefundPolicy = () => {
  return (
    <div className='PrivacyPolicy-wrapper'>
      <div className='PrivacyPolicy-header-wrapper baseContainer'>
        <div className='maxWidth'>
          <div className='breadcrumbs-wrapper'>
            <Link
              href={"/"}
              className='text-xsmall-18 grey-100 weight-600'
              style={{ opacity: 0.5 }}>
              HOME
            </Link>
            <ReactSVG src='/assets/next-arrow-small-ic.svg' />
            <p className='text-xsmall-18 white weight-700'>REFUND POLICY</p>
          </div>
          <p className='section-main-header large white'>Refund Policy</p>
        </div>
      </div>

      <div className='PloicyBody baseContainer'>
        <div className='maxWidth'>
          <div className='wrapper'>
            <div className='right'>
              <div className='textBlock'>
                <div className='textWrapper'>
                  <p className='title'>Amherst Supply Refund Policy</p>
                  <p className='desc'>
                    At Amherst Supply, we aim to make your shopping experience as
                    smooth as possible, whether in-store or online. Our refund
                    policy ensures you know exactly what to expect when making a
                    return.
                  </p>
                </div>
                <div className='textWrapper'>
                  <p className='title'>
                    Eligibility for Returns (In-Store & Online)
                  </p>
                  <br /> <br />
                  <div className='desc'>
                    <ul>
                      <li>
                        <strong>Timeframe:</strong> Regularly stocked items are
                        eligible for return within 30 days of the original
                        purchase or delivery.
                        <br />
                        <br />
                      </li>
                      <li>
                        <strong>Condition:</strong> Items must be in original
                        packaging, unused, and in good condition.
                        <br />
                        <br />
                      </li>
                      <li>
                        <strong>Non-Returnable Items:</strong> Returns are not
                        accepted for special order items, items marked final sale,
                        or items purchased over 30 days ago. <br />
                        <br />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='title'>Lumber & Panel Products</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Lumber and panel items must not be weathered, cut, and
                        show any signs of use to receive a refund.
                      </li>
                      <li>
                        Quality issues with lumber must be reported within 24
                        hours of purchase.
                      </li>
                      <li>
                        Amherst Supply reserves the right to refuse refunds for
                        lumber and panel items after 7 days of purchase.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='title'>Refund Methods</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Refunds are issued by the original method of payment.
                      </li>
                      <br />
                      <li>
                        If payment was made by cheque, the refund will be subject
                        to a 21-day waiting period from the date of purchase,
                        after which a company cheque will be issued to complete
                        the refund
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='title'>Large Quantity Returns</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Large quantity returns may take up to 5 business days to
                        process due to verification procedures.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='title'>Return Pick-Up</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        If you require a pick-up of returns from your job site,
                        pick-up fees plus a handling charge may apply. For large
                        online orders, please contact our customer service for
                        details.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='title'>Online Returns Process</p>
                  <div className='desc'>
                    <ol>
                      <li>
                        Initiate the Return: Log in to your account and navigate
                        to your dashboard. Select the item you wish to return and
                        click on the &quot;Return&quot; button to start the
                        process.
                      </li>
                      <li>
                        Return Approval: Once submitted, our team will review your
                        request. The status will change to &quot;approved&quot;
                        once it is approved by our team.
                      </li>
                      <li>
                        Shipping the Item: After approval, you will be provided
                        with a shipping label to send the product back to us.
                      </li>
                      <li>
                        Return Confirmation: Once we receive and confirm the
                        returned item, we will process your refund according to
                        our return policy.
                      </li>
                      <li>
                        Shipping Costs: Return shipping costs are the
                        responsibility of the customer, unless the return is due
                        to a shipping error or a defective product.
                      </li>
                    </ol>
                  </div>
                </div>
                <div className='textWrapper'>
                  <p className='title'>Online Refund Processing Timeline</p>
                  <div className='desc'>
                    <ul>
                      <li>
                        Refunds will be processed within 5-7 business days after
                        the item has been inspected and approved for a refund.
                      </li>
                    </ul>
                  </div>
                  <br />
                  <p className='desc'>
                    For further questions, please contact us at{' '}
                    <Link
                      href="mailto:hello@amherstsupply.com"
                      className="text-medium-24 blue-500"
                      style={{ cursor: 'pointer' }}
                    >
                      hello@amherstsupply.com
                    </Link>{' '}or call{' '}
                    <Link
                      href="tel:5197139318"
                      className="text-medium-24 blue-500"
                      style={{ cursor: 'pointer' }}
                    >
                      (519) 713-9318
                    </Link>. We appreciate
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
